export function parseChangelogItemTitle(value) {
    return value.toLowerCase().replaceAll(' ', '-').replaceAll('#', '-').replaceAll('.', '-');
}
